
export default {
  computed: {
    integration () {
      if (this.$page.props.brand === 'SBL') {
        return null
      }

      return this.$store.getters['rummage/integration']
    },
  },
}
